if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.minNumberInput = document.getElementById('price-range-number-min');
      this.maxNumberInput = document.getElementById('price-range-number-max');
      this.minValue = Number(this.minNumberInput.min);
      this.maxValue = Number(this.maxNumberInput.max);
      this.timeout = null;
      this.addEventListener('input', this.handleInput.bind(this));

      const searchParams = new URLSearchParams(window.location.href);
      const price_range = searchParams.get('filter.v.price_range');
      const price_gte = searchParams.get('filter.v.price.gte');
      const price_lte = searchParams.get('filter.v.price.lte');

      if (price_range) {
        document.querySelectorAll('[name="filter.v.price_range"]').forEach((input) => {
          if (input.value == price_range && price_range == [price_gte, price_lte].join('-')) {
            input.checked = true;
          }
        })
      }
    }

    /**
     * Handles 'input' events on the price range component.
     * @param {object} evt - Event object.
     */
    handleInput(evt) {
      if (evt.detail !== undefined) {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.updateSliderInputs(evt);
        }, 500);
      } else {
        this.updateSliderInputs(evt);
      }
    }

    /**
     * Updates the value of the 'number' type inputs.
     */
    updateNumberInputs() {
    }

    /**
     * Updates the value of the 'range' type inputs.
     * @param {object} evt - Event object.
     */
    updateSliderInputs(evt) {
    }
  }

  customElements.define('price-range', PriceRange);
}
